import React, { useEffect, useState } from "react";
import styles from "./modal.module.css";

const AnimatedText = ({ phrases }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true); // State for blinking

  useEffect(() => {
    setCurrentPhraseIndex(0);

    const intervalId = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) => {
        if (prevIndex >= phrases.length - 1) return prevIndex;
        return prevIndex + 1;
      });
    }, 4000);

    return () => clearInterval(intervalId);
  }, [phrases]);

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsVisible((prevVisible) => !prevVisible);
    }, 1000);

    return () => clearInterval(blinkInterval);
  }, []); // Empty dependency array ensures this runs only once

  return (
    <div style={{ width: "300px" }}> {/* Increased width from 300px to 450px */}
      <div
        className="progress mb-3"
        role="progressbar"
        aria-label="Success Animated striped"
        aria-valuenow="75"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          className={`progress-bar progress-bar-striped progress-bar-animated ${styles.bgmain}`}
          style={
            currentPhraseIndex === 0 ? { width: "33%" } : 
            currentPhraseIndex === 1 ? { width: "66%" } : { width: "100%" }
          }
        ></div>
      </div>
      <div className="d-flex text-center justify-content-center">
      <span 
  // className={isVisible ? "fade-in" : "fade-out"}
  style={{ 
    wordBreak: "break-all", 
    overflowWrap: "break-word", 
    maxWidth: "100%" 
  }}
  dangerouslySetInnerHTML={{ __html: phrases[currentPhraseIndex] }}
/>
      </div>
    </div>
  );
};

export const Modalprogress = ({ loading, msg }) => {
  return (
    <div
      className={`modal show fade modal-dialog-centered ${
        loading ? styles.disBlock : styles.disNone
      }`}
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg"> {/* Added modal-lg class for wider modal */}
        <div className="modal-content">
          <div className="modal-body progressbody d-flex  justify-content-center align-items-center">
            {Array.isArray(msg) ? (
              <span className="mx-2 mt-4 progresstxt">
                <AnimatedText key={loading ? "reload" : "idle"} phrases={msg} />
              </span>
            ) : (
              <div style={{ maxWidth: "450px" }}> {/* Increased width here too */}
              <div
              className="progress mb-3"
              role="progressbar"
              aria-label="Success Animated striped"
              aria-valuenow="75"
              aria-valuemin="0"
              aria-valuemax="100"
              
            >
              <div
                className={`progress-bar progress-bar-striped progress-bar-animated ${styles.bgmain}`}
                style={
                  { width: "100%" }
                }
              ></div>
            </div>
                <div>
              <span className="progresstxt">{msg}</span>
           </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
